import styled from '@emotion/styled';

export const SimulationMainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ProductSelectorContainer = styled.div`
  padding-bottom: 16px;
`;
